import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Box,
  TextField,
  MenuItem,
  Typography,
  Stepper,
  Step,
  StepLabel,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  Grid
} from "@mui/material";

import { useTypeIncomes } from "../../../Services/TypeIncome";
import { CalendarToday } from "@mui/icons-material";
import { IoClose } from "react-icons/io5";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";
import { FaDollarSign, FaCalendarAlt, FaUser, FaTimes } from "react-icons/fa";
import { MdTableChart } from "react-icons/md";
import { WarningAmber } from "@mui/icons-material";
import { useIncomesService, useGetContact } from "../../../Services/Incomes";
import { useSucursales } from "../../../Services/Sucursales";
import { useUserSuperEmpresa } from "../../../Context/AuthContext";
import { RiCommunityFill } from "react-icons/ri";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { BsFileEarmarkRuledFill } from "react-icons/bs";
import IncomesReport from "./IncomesReport";
import { ButtonStyle, ModalStyle, Input, Titulo, inputFecha, InputDescripcion, buttonAtras, buttonGuardar, buttonCancelar } from "../../../Layouts/CustomStyles";
import { useGetProfesional } from "../../../Services/Profesional";
import { formatCLP } from "../../FuncionesGenerales/FormatoCLP";
import { FormatRut } from "../../FuncionesGenerales/Rut";

const CustomStepIcon = ({ active, completed, icon }) => {
  const colorActive = "#2a8d74";
  const colorInactive = "#808285";
  const iconColor = active || completed ? colorActive : colorInactive;

  if (!React.isValidElement(icon)) return null;

  // Material-UI Icons
  if (icon.type?.muiName) {
    return React.cloneElement(icon, { htmlColor: iconColor, fontSize: "medium" });
  }

  // React-icons
  return React.cloneElement(icon, { color: iconColor, size: 24 });
};


const IncomeStore = ({ onSuccess }) => {
  const { incomeTypes } = useTypeIncomes();
  const { postIncomes } = useIncomesService();
  const { contacts, searchContacts, loadingContact } = useGetContact();
  const [selectedContact, setSelectedContact] = useState(null);
  const { getSucursales } = useSucursales();
  const { Usuario } = useUserSuperEmpresa();
  const [sucursales, setSucursales] = useState([]);
  const [open, setOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [warningOpen, setWarningOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [successAlertOpen, setSuccessAlertOpen] = useState(false);
  const [errorAlertOpen, setErrorAlertOpen] = useState(false);
  const [enviandoAlert, setEnviandoAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [openDialogExcel, setOpenDialogExcel] = useState(false);
  const { profesional } = useGetProfesional();
  const [details, setDetails] = useState([]);
  const [showDetails, setShowDetails] = useState(false);
  const [formData, setFormData] = useState({
    total_amount: "",
    tax_amount: "0.19",
    date: "",
    concept: "",
    branch_id: "",
    income_type_id: "",
    contact_id: selectedContact?.id ?? null,
    bank_account_id: "",
    due_date: "",
    user_id: Usuario?.id ?? null,
    id_profesional: "",
    showNewContactFields: false,
    name_contacto: "",
    email_contacto: "",
    phone_contacto: "",
    estado: " ",
  });

  useEffect(() => {
    if (Usuario?.id) {
      setFormData(prev => ({
        ...prev,
        user_id: Usuario.id

      }));
    }
  }, [Usuario]);

  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      contact_id: selectedContact?.id ?? null
    }));
  }, [selectedContact]);

  useEffect(() => {
    searchContacts();
  }, []);

  const handleAddDetail = () => {
  setDetails(prev => [...prev, {
    branch_id: "",
    amount: "",
    description: ""
  }]);
};

const handleRemoveDetail = (index) => {
  const updated = details.filter((_, i) => i !== index);
  setDetails(updated);
};

const handleChangeDetail = (index, field, value) => {
  const updated = [...details];
  updated[index][field] = value;
  setDetails(updated);
};
const totalDetalles = details.reduce(
  (acc, d) => acc + Number(d.amount || 0),
  0
);

  const steps = [
    { label: "Ingreso", fields: ["income_type_id"], icon: <MdTableChart /> },
    { label: "Sucursal", fields: ["branch_id"], icon: < RiCommunityFill /> },
    { label: "Fecha", fields: ["date", "due_date"], icon: <FaCalendarAlt /> },
    { label: "Contacto", fields: [], icon: <FaUser /> },
    { label: "Monto", fields: ["total_amount"], icon: <FaDollarSign /> },
  ];

  const tiposMedicos = [
    "Área Médica",
    "Salud",
    "Kinesiología",
    "Quiropráctico",
    "Nutrición",
    "Medicina General",
    "Rehabilitación"
  ];

  const esTipoMedico = tiposMedicos.includes(formData.income_type_name);


  // Función que valida si el step actual está completo
  const isStepComplete = (stepIndex) => {
    const stepFields = steps[stepIndex].fields;
    return stepFields.every(field => formData[field] && formData[field].toString().trim() !== "");
  };
  // handleChange solo actualiza los datos, NO avanza
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Formatear RUT
    if (name === "rut_contacto") {
      setFormData(prev => ({
        ...prev,
        [name]: FormatRut(value)
      }));
      return;
    }

    // Formateo especial para monto
    if (name === "total_amount") {
      const valorLimpio = value.replace(/\./g, "").replace(/\$/g, "");
      setFormData(prev => ({
        ...prev,
        total_amount: Number(valorLimpio)
      }));
      return;
    }

    // Para cuando seleccionan el tipo de ingreso
    if (name === "income_type_id") {
      const seleccionado = incomeTypes.find(t => t.id === Number(value));
      setFormData(prev => ({
        ...prev,
        income_type_id: value,
        income_type_name: seleccionado?.name || ""
      }));
      return;
    }

    // Para cualquier otro campo
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };



  const fetchData = async () => {
    try {
      setLoading(true);


      const data = await getSucursales();
      setSucursales(data);
    } catch (err) {
      console.error(err.message || "Error al cargar ingresos");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);


  const handleBack = () => setActiveStep(prev => Math.max(prev - 1, 0));
  const handleCloseWarning = () => setWarningOpen(false);



  const handleNext = () => {
    if (isStepComplete(activeStep)) {
      setActiveStep(prev => prev + 1); // solo avanza
    } else {
      setWarningOpen(true);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isStepComplete(activeStep)) return;

    setLoading(true);
    setEnviandoAlert(true);

    try {
      let payload = { ...formData };

      if (selectedContact) {
        payload.contact_id = selectedContact.id;
        // limpiar campos de contacto nuevo por si acaso
        delete payload.rut_contacto;
        delete payload.name_contacto;
        delete payload.email_contacto;
        delete payload.phone_contacto;
      } else if (!formData.showNewContactFields) {
        // Ningún contacto → limpiar campos
        delete payload.contact_id;
        delete payload.rut_contacto;
        delete payload.name_contacto;
        delete payload.email_contacto;
        delete payload.phone_contacto;
      }
      
        if (showDetails && details.length > 0) {

      // Validación
      const totalDetalles = details.reduce(
        (acc, d) => acc + Number(d.amount || 0),
        0
      );

      if (totalDetalles !== Number(formData.total_amount)) {
        setErrorAlertOpen(true);
        setAlertMessage("El total distribuido debe coincidir con el monto total");
        setLoading(false);
        setEnviandoAlert(false);
        return;
      }

      // 👉 limpiar datos antes de enviar
      payload.details = details.map(d => ({
        branch_id: d.branch_id,
        amount: Number(d.amount),
        description: d.description || null
      }));
    }

      await postIncomes(payload);

      setSuccessAlertOpen(true);
      setAlertMessage('Se ha ingresado correctamente.');
      if (onSuccess) onSuccess();

      // Limpiar formulario
      setFormData({
        total_amount: "",
        tax_amount: "0.19",
        date: "",
        concept: "",
        branch_id: "",
        income_type_id: "",
        id_profesional: "",
        contact_id: null,
        bank_account_id: "",
        due_date: "",
        user_id: Usuario?.id ?? null,
        showNewContactFields: false,
        rut_contacto: "",
        name_contacto: "",
        email_contacto: "",
        phone_contacto: "",
        estado: " "
      });
      setDetails([]);          
      setShowDetails(false);
      setSelectedContact(null);
      setActiveStep(0);
      setOpen(false);

    } catch (error) {
      console.error("Error al crear ingreso:", error);
      setErrorAlertOpen(true);
      setAlertMessage(error.toString() || "Ocurrió un error inesperado al crear el ingreso.");
    } finally {
      setLoading(false);
      setEnviandoAlert(false);
      handleClose();
    }
  };



  const handleClose = () => {
    setOpen(false);
    setActiveStep(0);
    setFormData({
      total_amount: "",
      tax_amount: "",
      date: "",
      concept: "",
      id_profesional: "",
      branch_id: "",
      income_type_id: "",
      contact_id: "",
      bank_account_id: "",
      due_date: "",
      user_id: Usuario?.id ?? null,
      rut_contacto: "",
      name_contacto: "",
      email_contacto: "",
      phone_contacto: "",
      estado: " "
    });
  };



  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Button
          startIcon={< AddCircleOutlineIcon />}
          variant="contained"
          sx={{
            backgroundColor: "#2a8d74",
            borderRadius: "50px",
            textTransform: "none",
            fontFamily: "Poppins",
          }}
          onClick={() => setOpen(true)}>
          Nuevo Ingreso
        </Button>

        <Button
          startIcon={< BsFileEarmarkRuledFill />}
          variant="contained"
          sx={{
            backgroundColor: "#2a8d74",
            borderRadius: "50px",
            textTransform: "none",
            fontFamily: "Poppins",
          }}
          onClick={() => setOpenDialogExcel(true)}
        >
          Descargar Ingreso RME
        </Button>
      </Box>
      <Modal
        open={open}
      >

        <Box
          sx={ModalStyle}
        >
          <IconButton
            onClick={handleClose}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <FaTimes />
          </IconButton>

          <Typography sx={Titulo} mb={2}>
            Crear nuevo ingreso
          </Typography>

          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((step, index) => (
              <Step key={index}>
                <StepLabel
                  StepIconComponent={(props) => <CustomStepIcon {...props} icon={step.icon} />}
                  sx={{
                    "& .MuiStepLabel-label": {
                      color: activeStep >= index ? "#2a8d74" : "#808285",
                      fontFamily: "Poppins", // 👈 aquí le pones tu fuente
                      fontWeight: 500,        // opcional: grosor de la fuente
                      fontSize: "0.9rem",
                    },
                  }}
                >
                  {step.label}
                </StepLabel>

              </Step>
            ))}
          </Stepper>

          <form onSubmit={handleSubmit}>

            {/* STEP 0 */}
            {activeStep === 0 && (
              <>

                {/* Tipo de ingreso */}
                <TextField
                  select
                  fullWidth
                  label="Estado ingreso"
                  name="estado"
                  sx={Input}
                  value={formData.estado}
                  onChange={handleChange}
                  margin="normal"
                >
                  <MenuItem value="REGISTRADO">registrado</MenuItem>
                  <MenuItem value="PENDIENTE">Pendiente</MenuItem>
                  <MenuItem value="PROCESO">Proceso</MenuItem>
                  <MenuItem value="NO PAGO">No pagado</MenuItem>
                  <MenuItem value="PAGADO">Pagado</MenuItem>
                  <MenuItem value="ANULADO">Anulado</MenuItem>

                </TextField>
                <TextField
                  select
                  fullWidth
                  label="Tipo de Ingreso"
                  name="income_type_id"
                  sx={Input}
                  value={formData.income_type_id}
                  onChange={handleChange}
                  margin="normal"
                >
                  {incomeTypes.map((type) => (
                    <MenuItem key={type.id} value={type.id}>
                      {type.name}
                    </MenuItem>
                  ))}
                </TextField>


                {/* Profesionales filtrados */}
                {esTipoMedico && (
                  <FormControl fullWidth sx={{ ...Input, mt: 2 }}>
                    <InputLabel>Profesional</InputLabel>
                    <Select
                      name="id_profesional"
                      value={formData.id_profesional || ""}
                      label="Profesional"
                      onChange={handleChange}
                    >
                      {profesional?.map((p) => (
                        <MenuItem key={p.id} value={p.id}>
                          {p.nombre}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}


              </>
            )}


            {activeStep === 1 && (
              <TextField
                select
                fullWidth
                label="Sucursal"
                name="branch_id"
                sx={Input}
                value={formData.branch_id}
                onChange={handleChange}
                margin="normal"
              >

                {sucursales.length > 0 ? (
                  sucursales.map((sucursal) => (
                    <MenuItem key={sucursal.id} value={sucursal.id}>
                      {sucursal.name} {/* 👈 se muestra el nombre */}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No hay sucursales disponibles</MenuItem>
                )}
              </TextField>
            )}

            {activeStep === 2 && (
              <Box sx={
                {
                  display:'flex',
                  alignItems:'center',
                  justifyContent:'space-around',
                  
                }
              }>
              <Box>
                <TextField
                  fullWidth
                  label="Fecha"
                  name="date"
                  type="date"
                  value={formData.date}
                  onChange={handleChange}
                  margin="normal"
                  sx={inputFecha}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <CalendarToday />
                      </InputAdornment>
                    ),
                  }}
                />
                </Box>
                   <Box>
                <TextField
                  fullWidth
                  label="Fecha Vencimiento"
                  name="due_date"
                  type="date"
                  sx={inputFecha}
                  value={formData.due_date}
                  onChange={handleChange}
                  margin="normal"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <CalendarToday />
                      </InputAdornment>
                    ),
                  }}
                />
                </Box>
              </Box>
            )}

            {activeStep === 3 && (
              <>
                {/* Autocomplete para buscar contacto */}
                <FormControl fullWidth>
                  <InputLabel id="select-contact-label">Seleccionar contacto</InputLabel>
                  <Select
                    labelId="select-contact-label"
                    value={selectedContact?.id || ""}
                    onChange={(e) => {
                      const contact = contacts.find(c => c.id === e.target.value);
                      setSelectedContact(contact);
                    }}
                  >
                    {loadingContact ? (
                      <MenuItem disabled>Cargando contactos...</MenuItem>
                    ) : (
                      contacts.map((contact) => (
                        <MenuItem key={contact.id} value={contact.id}>
                          {contact.name} - {contact.rut}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>

                {/* Mostrar botón "Agregar contacto" solo si no hay contacto seleccionado */}
                {!selectedContact && !formData.showNewContactFields && (
                  <Button
                    variant="outlined"
                    sx={{ mt: 1 }}
                    onClick={() =>
                      setFormData(prev => ({ ...prev, showNewContactFields: true }))
                    }
                  >
                    Agregar contacto
                  </Button>
                )}

                {/* Campos para crear nuevo contacto, solo si se presionó el botón */}
                {formData.showNewContactFields && (
                  <>
                    <TextField
                      fullWidth
                      label="RUT"
                      sx={Input}
                      name="rut_contacto"
                      value={formData.rut_contacto || ""}
                      onChange={handleChange}
                      margin="normal"
                    />
                    <TextField
                      fullWidth
                      label="Nombre"
                      sx={Input}
                      name="name_contacto"
                      value={formData.name_contacto || ""}
                      onChange={handleChange}
                      margin="normal"
                    />
                    <TextField
                      fullWidth
                      label="Email"
                      sx={Input}
                      name="email_contacto"
                      value={formData.email_contacto || ""}
                      onChange={handleChange}
                      margin="normal"
                    />
                    <TextField
                      fullWidth
                      label="Teléfono"
                      sx={Input}
                      name="phone_contacto"
                      value={formData.phone_contacto || ""}
                      onChange={handleChange}
                      margin="normal"
                    />
                  </>
                )}






                <TextField
                  fullWidth
                  label="Descripcion de ingreso"
                  name="concept"
                  multiline
                  rows={2}
                  sx={InputDescripcion}
                  value={formData.concept}
                  onChange={handleChange}
                  margin="normal"
                />
              </>
            )}
            {activeStep === 4 && (
  <>
    <TextField
      fullWidth
      label="Monto Total"
      name="total_amount"
      sx={Input}
      value={formatCLP(formData.total_amount || 0)}
      onChange={handleChange}
      margin="normal"
    />

    {/* BOTÓN ACTIVAR DISTRIBUCIÓN */}
    {!showDetails && (
      <Button
        variant="outlined"
        sx={{ ...buttonGuardar, mt: 2 }}
        onClick={() => {
          setShowDetails(true);
          if (details.length === 0) handleAddDetail();
        }}
      >
        Distribuir monto por sucursales
      </Button>
    )}

    {/* DETALLES */}
    {showDetails && (
      <Box mt={3} sx={{border:'1px solid', p:1, borderColor:'#585857'}}>
        {details.map((item, index) => (
          <Grid container spacing={2} key={index} mb={2}>
             <Grid size={12}sx={{display:'flex', justifyContent:"flex-end"}} >
              <Button
                color="error"
                onClick={() => handleRemoveDetail(index)}
              >
                X
              </Button>
            </Grid>
            {/* Sucursal */}
            <Grid size={12}>
              <TextField
                select
                fullWidth
                label="Sucursal"
                value={item.branch_id}
                onChange={(e) =>
                  handleChangeDetail(index, "branch_id", e.target.value)
                }
              >
                {sucursales.map((s) => (
                  <MenuItem key={s.id} value={s.id}>
                    {s.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            {/* Monto */}
            <Grid  size={12}>
            <TextField
  fullWidth
  label="Monto"
  type="text"
  value={formatCLP(item.amount || 0)}
  onChange={(e) => {
    const valor = e.target.value
      .replace(/\./g, "")
      .replace(/\$/g, "")
      .replace(/\D/g, "");

    handleChangeDetail(index, "amount", valor);
  }}
/>
            </Grid>

            {/* Descripción */}
            <Grid size={12}>
              <TextField
                fullWidth
                label="Descripción"
                value={item.description}
                onChange={(e) =>
                  handleChangeDetail(index, "description", e.target.value)
                }
              />
            </Grid>

          
           
          </Grid>
        ))}

        {/* BOTONES */}
        <Box display="flex" justifyContent="center" gap={2}>
          <Button variant="outlined" sx={buttonGuardar} onClick={handleAddDetail}>
            + Agregar sucursal
          </Button>

          <Button
            sx={buttonCancelar}
            onClick={() => {
              setShowDetails(false);
              setDetails([]);
            }}
          >
            Cancelar distribución
          </Button>
        </Box>

        {/* TOTAL */}
        <Typography mt={2}>
          Total distribuido: {formatCLP(totalDetalles)}
        </Typography>
      </Box>
    )}
  </>
)}


            {/* Botones */}
            <Box mt={2} display="flex" justifyContent="flex-end" gap={1}>
              {activeStep > 0 && (
                <Button sx={buttonAtras} onClick={handleBack}>Atrás</Button>
              )}

              {activeStep < steps.length - 1 ? (
                <Button variant="contained" sx={ButtonStyle} onClick={handleNext}>
                  Siguiente
                </Button>
              ) : (
                <Button type="submit" sx={buttonGuardar}>
                  {loading ? (
                    <CircularProgress size={20} color="inherit" /> // spinner pequeño dentro
                  ) : (
                    "Guardar"
                  )}
                </Button>
              )}

            </Box>

          </form>
        </Box>
      </Modal>
      <Dialog open={warningOpen} onClose={handleCloseWarning}>
        <DialogTitle sx={{ textAlign: "center", fontFamily: "Poppins", color: "#585857" }}>
          <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
            <WarningAmber sx={{ fontSize: 50, color: "orange" }} />
            Campos incompletos
          </Box>
        </DialogTitle>

        <DialogContent sx={{ textAlign: "center" }}>
          <DialogContentText sx={{ color: "#585857", fontFamily: "Poppins" }}>
            Por favor completa todos los campos requeridos antes de continuar.
          </DialogContentText>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center" }}>
          <Button onClick={handleCloseWarning} variant="contained" sx={ButtonStyle}>
            Entendido
          </Button>
        </DialogActions>
      </Dialog>

      <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '350px',
            height: 'auto',
            bgcolor: '#ffff',
            boxShadow: 24,
            p: 1,
            borderRadius: '10px',
            '@media (max-width: 500px)': {
              width: '90%',
            },
          }}
        >
          <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
            <IoClose />
          </section>
          <section style={{ textAlign: 'center' }}>
            <FaRegCircleCheck style={{ color: 'green', fontSize: '2rem', marginBottom: '1rem' }} />
            <p style={{ fontFamily: 'Poppins', color: '#585857', fontSize: '0.8rem', fontWeight: '600', marginTop: "-5px" }}>
              {alertMessage}
            </p>
          </section>
        </Box>
      </Modal>

      <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '350px',
            height: 'auto',
            bgcolor: '#ffff',
            boxShadow: 24,
            p: 1,
            borderRadius: '10px',
            '@media (max-width: 500px)': {
              width: '90%',
            },
          }}
        >
          <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
            <IoClose />
          </section>
          <section style={{ textAlign: 'center' }}>
            <BiErrorCircle style={{ color: 'red', fontSize: '2rem', marginBottom: '1rem' }} />
            <p style={{ fontFamily: 'Poppins', color: '#585857', fontSize: '0.8rem', fontWeight: '600' }}>
              {alertMessage}
            </p>
          </section>
        </Box>
      </Modal>

      <Modal open={enviandoAlert} onClose={() => setEnviandoAlert(false)}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '350px',
            height: 'auto',
            bgcolor: '#ffff',
            boxShadow: 24,
            p: 1,
            borderRadius: '10px',
            '@media (max-width: 500px)': {
              width: '90%',
            },
          }}
        >
          <section style={{ textAlign: 'center', padding: '1rem' }}>
            <CircularProgress style={{ color: '#e83b33' }} />
            <p style={{ fontFamily: 'Poppins', color: '#585857', fontSize: '0.8rem', fontWeight: '600', marginTop: '20px' }}>
              Procesando solicitud...
            </p>
          </section>
        </Box>
      </Modal>

      <Dialog
        open={openDialogExcel}
        onClose={() => setOpenDialogExcel(false)}
        fullWidth
        maxWidth="sm"
      >


        <DialogContent dividers sx={{ p: 3 }}>

          <IncomesReport />
        </DialogContent>


      </Dialog>
    </>
  );
};

export default IncomeStore;


